export interface MappedUser {
  id: number;
  userCode?: string;
  userRef?: string;
  name: string;
  fullName?: string;
  email: string;
  phone?: string;
  phoneNumber?: string;
  role: string;
  postalCode?: string;
  pincode?: string;
  state?: string;
  district?: string;
  blockTehsil?: string;
  panCardNo?: string;
  image?: string;
  address?: string;
  isEmailVerified?: boolean;
  isBlocked?: boolean;
  isActive?: boolean;
  createdAt?: string;
  updatedAt?: string;

  // Ambassador fields
  isAmbassador?: boolean;
  is_ambassador?: number | boolean;
  ambassadorStatus?: 'PENDING' | 'APPROVED' | 'REJECTED' | null;
  ambassador_status?: 'PENDING' | 'APPROVED' | 'REJECTED' | null;
  ambassadorAppliedAt?: string;
  ambassador_applied_at?: string;
  ambassadorApprovedAt?: string;
  ambassador_approved_at?: string;
  ambassadorId?: string;
  my_ambassador_id?: string;
  ambassadorRecord?: any;
  ambassador_record?: any;
  ambassadorAcceptanceStatus?: string;
  ambassador_acceptance_status?: string;

  // KYC Fields
  donor_type?: string;
  donorType?: string;
  kyc_status?: string;
  kycStatus?: string;
  kyc_submitted_at?: string;
  kycSubmittedAt?: string;
  ambassador_name?: string;
  ambassadorName?: string;
  ambassador_phone?: string;
  ambassadorPhone?: string;
  whatsapp_number?: string;
  whatsappNumber?: string;
  full_address?: string;
  fullAddress?: string;
  city?: string;
  country?: string;
  is_whatsapp_same_as_mobile?: boolean | number;
  isWhatsappSameAsMobile?: boolean | number;
  referencer_id?: string;
  referencerId?: string;

  // Citizen
  photo_id_type?: string;
  photoIdType?: string;
  photo_id_number?: string;
  photoIdNumber?: string;
  passport_size_photo?: string;
  passportSizePhoto?: string;
  id_document_scan?: string;
  idDocumentScan?: string;
  id_document_scan_back?: string;
  idDocumentScanBack?: string;
  address_proof_type?: string;
  addressProofType?: string;
  address_proof_number?: string;
  addressProofNumber?: string;
  address_document_scan?: string;
  addressDocumentScan?: string;
  address_document_scan_back?: string;
  addressDocumentScanBack?: string;
  address_proof_same_as_photo_id?: boolean | number;
  addressProofSameAsPhotoId?: boolean | number;
  alumni_verified?: boolean | number;
  alumniVerified?: boolean | number;

  // Organization
  org_name?: string;
  orgName?: string;
  org_email?: string;
  orgEmail?: string;
  org_pan?: string;
  orgPan?: string;
  org_govt_id?: string;
  orgGovtId?: string;
  org_rep_name?: string;
  orgRepName?: string;
  org_rep_email?: string;
  orgRepEmail?: string;
  org_rep_phone?: string;
  orgRepPhone?: string;
  org_rep_whatsapp?: string;
  orgRepWhatsapp?: string;
  is_org_whatsapp_same_as_mobile?: boolean | number;
  isOrgWhatsappSameAsMobile?: boolean | number;
  org_pan_scan?: string;
  orgPanScan?: string;
  org_govt_id_scan?: string;
  orgGovtIdScan?: string;
  declaration_agreed?: boolean | number;
  declarationAgreed?: boolean | number;
  isReferencer?: boolean;
  referencerRecord?: any;

  // Cross-project profile sharing consent
  consent_for_profile_sharing?: boolean | number;
  consentForProfileSharing?: boolean | number;
  consent_given_at?: string | null;
}

export function mapBackendUserToFrontend(backendUser: any, existingUser?: any): MappedUser {
  return {
    id: backendUser.id || existingUser?.id || 0,
    userCode: backendUser.user_code || backendUser.userCode || existingUser?.userCode || '',
    name: backendUser.name || existingUser?.name || '',
    fullName: backendUser.name || existingUser?.fullName || existingUser?.name || '',
    email: backendUser.email || existingUser?.email || '',
    phone: backendUser.phone || existingUser?.phone || '',
    phoneNumber: backendUser.phone || backendUser.phoneNumber || existingUser?.phoneNumber || existingUser?.phone || '',
    role: backendUser.role || existingUser?.role || 'USER',
    postalCode: backendUser.postal_code || backendUser.postalCode || backendUser.pincode || existingUser?.postalCode || existingUser?.pincode,
    pincode: backendUser.postal_code || backendUser.postalCode || backendUser.pincode || existingUser?.pincode || existingUser?.postalCode,
    state: backendUser.state || existingUser?.state,
    district: backendUser.district || existingUser?.district,
    blockTehsil: backendUser.block_tehsil || backendUser.blockTehsil || existingUser?.blockTehsil,
    panCardNo: backendUser.pan_card_no || backendUser.panCardNo || existingUser?.panCardNo,
    image: backendUser.image || existingUser?.image,
    isEmailVerified: backendUser.is_email_verified !== undefined ? backendUser.is_email_verified : existingUser?.isEmailVerified,
    isBlocked: backendUser.is_blocked !== undefined ? backendUser.is_blocked : existingUser?.isBlocked,
    isActive: backendUser.is_active !== undefined ? backendUser.is_active : existingUser?.isActive,
    createdAt: backendUser.created_at || backendUser.createdAt || existingUser?.createdAt,
    updatedAt: backendUser.updated_at || backendUser.updatedAt || existingUser?.updatedAt,

    // Ambassador
    isAmbassador: !!(backendUser.is_ambassador === 1 || backendUser.is_ambassador === true || backendUser.role === 'AMBASSADOR' || existingUser?.isAmbassador),
    is_ambassador: backendUser.is_ambassador,
    ambassadorStatus: backendUser.ambassador_status || backendUser.ambassadorStatus || existingUser?.ambassadorStatus || null,
    ambassador_status: backendUser.ambassador_status || existingUser?.ambassador_status || null,
    ambassadorAppliedAt: backendUser.ambassador_applied_at || backendUser.ambassadorAppliedAt || existingUser?.ambassadorAppliedAt,
    ambassador_applied_at: backendUser.ambassador_applied_at,
    ambassadorApprovedAt: backendUser.ambassador_approved_at || backendUser.ambassadorApprovedAt || existingUser?.ambassadorApprovedAt,
    ambassador_approved_at: backendUser.ambassador_approved_at,
    // ambassador_id = the user's OWN ambassador record ID
    // my_ambassador_id = the ID of the ambassador they chose as their own referencer
    // Keep these separate — conflating them causes wrong ID lookups
    ambassadorId: backendUser.ambassador_id || backendUser.ambassadorId || existingUser?.ambassadorId,
    my_ambassador_id: backendUser.my_ambassador_id || existingUser?.my_ambassador_id,
    ambassadorRecord: backendUser.ambassador_record || backendUser.ambassadorRecord || existingUser?.ambassadorRecord,
    ambassador_record: backendUser.ambassador_record,
    ambassadorAcceptanceStatus: backendUser.ambassador_acceptance_status || backendUser.ambassadorAcceptanceStatus,
    ambassador_acceptance_status: backendUser.ambassador_acceptance_status,

    // KYC — use explicit undefined checks so a null value from the backend
    // (e.g. kyc_status = null for a new user) is not replaced by a stale
    // existingUser value from a different account that was previously loaded.
    donor_type: backendUser.donor_type !== undefined ? backendUser.donor_type : (backendUser.donorType !== undefined ? backendUser.donorType : existingUser?.donor_type),
    donorType: backendUser.donor_type !== undefined ? backendUser.donor_type : (backendUser.donorType !== undefined ? backendUser.donorType : existingUser?.donorType),
    kyc_status: backendUser.kyc_status !== undefined ? backendUser.kyc_status : (backendUser.kycStatus !== undefined ? backendUser.kycStatus : existingUser?.kyc_status),
    kycStatus: backendUser.kyc_status !== undefined ? backendUser.kyc_status : (backendUser.kycStatus !== undefined ? backendUser.kycStatus : existingUser?.kycStatus),
    kyc_submitted_at: backendUser.kyc_submitted_at !== undefined ? backendUser.kyc_submitted_at : (backendUser.kycSubmittedAt !== undefined ? backendUser.kycSubmittedAt : existingUser?.kyc_submitted_at),
    kycSubmittedAt: backendUser.kyc_submitted_at !== undefined ? backendUser.kyc_submitted_at : (backendUser.kycSubmittedAt !== undefined ? backendUser.kycSubmittedAt : existingUser?.kycSubmittedAt),

    // ambassador_name/phone/email come from the ambassadors table JOIN in the API response
    ambassador_name: backendUser.ambassador_name || existingUser?.ambassador_name,
    ambassadorName: backendUser.ambassador_name || existingUser?.ambassadorName,
    ambassador_phone: backendUser.ambassador_phone || existingUser?.ambassador_phone,
    ambassadorPhone: backendUser.ambassador_phone || existingUser?.ambassadorPhone,

    whatsapp_number: backendUser.whatsapp_number || backendUser.whatsappNumber || existingUser?.whatsapp_number,
    whatsappNumber: backendUser.whatsapp_number || backendUser.whatsappNumber || existingUser?.whatsappNumber,
    is_whatsapp_same_as_mobile: backendUser.is_whatsapp_same_as_mobile !== undefined ? backendUser.is_whatsapp_same_as_mobile : existingUser?.is_whatsapp_same_as_mobile,
    isWhatsappSameAsMobile: backendUser.is_whatsapp_same_as_mobile !== undefined ? backendUser.is_whatsapp_same_as_mobile : existingUser?.isWhatsappSameAsMobile,
    referencer_id: backendUser.referencer_id || backendUser.referencerId || existingUser?.referencer_id,
    referencerId: backendUser.referencer_id || backendUser.referencerId || existingUser?.referencerId,
    isReferencer: backendUser.is_referencer !== undefined ? backendUser.is_referencer : (backendUser.role === 'AMBASSADOR' || backendUser.is_ambassador === 1 || existingUser?.isReferencer),
    referencerRecord: backendUser.referencer_record || backendUser.referencerRecord || existingUser?.referencerRecord,

    full_address: backendUser.full_address || backendUser.fullAddress || existingUser?.full_address,
    fullAddress: backendUser.full_address || backendUser.fullAddress || existingUser?.fullAddress,
    city: backendUser.city || backendUser.district || existingUser?.city || existingUser?.district,
    country: backendUser.country || existingUser?.country || 'India',

    photo_id_type: backendUser.photo_id_type || backendUser.photoIdType || existingUser?.photo_id_type,
    photoIdType: backendUser.photo_id_type || backendUser.photoIdType || existingUser?.photoIdType,
    photo_id_number: backendUser.photo_id_number || backendUser.photoIdNumber || existingUser?.photo_id_number,
    photoIdNumber: backendUser.photo_id_number || backendUser.photoIdNumber || existingUser?.photoIdNumber,
    passport_size_photo: backendUser.passport_size_photo || backendUser.passportSizePhoto || existingUser?.passport_size_photo,
    passportSizePhoto: backendUser.passport_size_photo || backendUser.passportSizePhoto || existingUser?.passportSizePhoto,
    id_document_scan: backendUser.id_document_scan || backendUser.idDocumentScan || existingUser?.id_document_scan,
    idDocumentScan: backendUser.id_document_scan || backendUser.idDocumentScan || existingUser?.idDocumentScan,
    id_document_scan_back: backendUser.id_document_scan_back || backendUser.idDocumentScanBack || existingUser?.id_document_scan_back,
    idDocumentScanBack: backendUser.id_document_scan_back || backendUser.idDocumentScanBack || existingUser?.idDocumentScanBack,
    address_proof_type: backendUser.address_proof_type || backendUser.addressProofType || existingUser?.address_proof_type,
    addressProofType: backendUser.address_proof_type || backendUser.addressProofType || existingUser?.addressProofType,
    address_proof_number: backendUser.address_proof_number || backendUser.addressProofNumber || existingUser?.address_proof_number,
    addressProofNumber: backendUser.address_proof_number || backendUser.addressProofNumber || existingUser?.addressProofNumber,
    address_document_scan: backendUser.address_document_scan || backendUser.addressDocumentScan || existingUser?.address_document_scan,
    addressDocumentScan: backendUser.address_document_scan || backendUser.addressDocumentScan || existingUser?.addressDocumentScan,
    address_document_scan_back: backendUser.address_document_scan_back || backendUser.addressDocumentScanBack || existingUser?.address_document_scan_back,
    addressDocumentScanBack: backendUser.address_document_scan_back || backendUser.addressDocumentScanBack || existingUser?.addressDocumentScanBack,
    address_proof_same_as_photo_id: backendUser.address_proof_same_as_photo_id !== undefined ? backendUser.address_proof_same_as_photo_id : existingUser?.address_proof_same_as_photo_id,
    addressProofSameAsPhotoId: backendUser.address_proof_same_as_photo_id !== undefined ? backendUser.address_proof_same_as_photo_id : existingUser?.addressProofSameAsPhotoId,
    alumni_verified: backendUser.alumni_verified !== undefined ? backendUser.alumni_verified : existingUser?.alumni_verified,
    alumniVerified: backendUser.alumni_verified !== undefined ? backendUser.alumni_verified : existingUser?.alumniVerified,

    org_name: backendUser.org_name || backendUser.orgName || existingUser?.org_name,
    orgName: backendUser.org_name || backendUser.orgName || existingUser?.orgName,
    org_email: backendUser.org_email || backendUser.orgEmail || existingUser?.org_email,
    orgEmail: backendUser.org_email || backendUser.orgEmail || existingUser?.orgEmail,
    org_pan: backendUser.org_pan || backendUser.orgPan || existingUser?.org_pan,
    orgPan: backendUser.org_pan || backendUser.orgPan || existingUser?.orgPan,
    org_govt_id: backendUser.org_govt_id || backendUser.orgGovtId || existingUser?.org_govt_id,
    orgGovtId: backendUser.org_govt_id || backendUser.orgGovtId || existingUser?.orgGovtId,

    org_rep_name: backendUser.org_rep_name || backendUser.orgRepName || existingUser?.org_rep_name,
    orgRepName: backendUser.org_rep_name || backendUser.orgRepName || existingUser?.orgRepName,
    org_rep_email: backendUser.org_rep_email || backendUser.orgRepEmail || existingUser?.org_rep_email,
    orgRepEmail: backendUser.org_rep_email || backendUser.orgRepEmail || existingUser?.orgRepEmail,
    org_rep_phone: backendUser.org_rep_phone || backendUser.orgRepPhone || existingUser?.org_rep_phone,
    orgRepPhone: backendUser.org_rep_phone || backendUser.orgRepPhone || existingUser?.orgRepPhone,
    org_rep_whatsapp: backendUser.org_rep_whatsapp || backendUser.orgRepWhatsapp || existingUser?.org_rep_whatsapp,
    orgRepWhatsapp: backendUser.org_rep_whatsapp || backendUser.orgRepWhatsapp || existingUser?.orgRepWhatsapp,
    is_org_whatsapp_same_as_mobile: backendUser.is_org_whatsapp_same_as_mobile !== undefined ? backendUser.is_org_whatsapp_same_as_mobile : existingUser?.is_org_whatsapp_same_as_mobile,
    isOrgWhatsappSameAsMobile: backendUser.is_org_whatsapp_same_as_mobile !== undefined ? backendUser.is_org_whatsapp_same_as_mobile : existingUser?.isOrgWhatsappSameAsMobile,

    org_pan_scan: backendUser.org_pan_scan || backendUser.orgPanScan || existingUser?.org_pan_scan,
    orgPanScan: backendUser.org_pan_scan || backendUser.orgPanScan || existingUser?.orgPanScan,
    org_govt_id_scan: backendUser.org_govt_id_scan || backendUser.orgGovtIdScan || existingUser?.org_govt_id_scan,
    orgGovtIdScan: backendUser.org_govt_id_scan || backendUser.orgGovtIdScan || existingUser?.orgGovtIdScan,

    declaration_agreed: backendUser.declaration_agreed !== undefined ? backendUser.declaration_agreed : existingUser?.declaration_agreed,
    declarationAgreed: backendUser.declaration_agreed !== undefined ? backendUser.declaration_agreed : existingUser?.declarationAgreed,

    consent_for_profile_sharing: backendUser.consent_for_profile_sharing !== undefined ? backendUser.consent_for_profile_sharing : existingUser?.consent_for_profile_sharing,
    consentForProfileSharing: backendUser.consent_for_profile_sharing !== undefined ? backendUser.consent_for_profile_sharing : existingUser?.consentForProfileSharing,
    consent_given_at: backendUser.consent_given_at !== undefined ? backendUser.consent_given_at : existingUser?.consent_given_at,
  };
}

export function mapBackendProjectToFrontend(backendProject: any): any {
  const targetAmount = backendProject.target_amount || backendProject.goalAmount || 0;
  const raisedAmount = backendProject.raised_amount || backendProject.raisedAmount || 0;

  const progressPercentage = targetAmount > 0
    ? Math.min(100, (raisedAmount / targetAmount) * 100)
    : 0;

  const remainingAmount = Math.max(0, targetAmount - raisedAmount);

  return {
    id: backendProject.id,
    title: backendProject.title || '',
    description: backendProject.description || '',
    goalAmount: targetAmount,
    raisedAmount: raisedAmount,
    imageUrl: backendProject.image_url || backendProject.thumbnail_url || backendProject.imageUrl,
    thumbnailUrl: backendProject.thumbnail_url || backendProject.image_url || backendProject.thumbnailUrl,
    status: backendProject.status?.toLowerCase() || 'active',
    priority: backendProject.priority?.toLowerCase() || 'medium',
    isFeatured: backendProject.is_featured === 1 || backendProject.is_featured === true || backendProject.isFeatured === true,
    category: backendProject.category_id || backendProject.category,
    categoryId: backendProject.category_id || backendProject.categoryId,
    location: backendProject.location || '',
    endDate: backendProject.end_date || backendProject.endDate,
    startDate: backendProject.start_date || backendProject.startDate,
    projectCode: backendProject.project_code || backendProject.projectCode || '',
    progressPercentage,
    remainingAmount,
    createdAt: backendProject.created_at || backendProject.createdAt,
    updatedAt: backendProject.updated_at || backendProject.updatedAt,
  };
}

export function mapBackendProjectsToFrontend(backendProjects: any[]): any[] {
  if (!Array.isArray(backendProjects)) {
    return [];
  }
  return backendProjects.map(mapBackendProjectToFrontend);
}

export function mapBackendDonationToFrontend(backendDonation: any): any {
  return {
    id: backendDonation.id,
    donationCode: backendDonation.donation_code || backendDonation.donationCode,
    userId: backendDonation.user_id || backendDonation.userId,
    projectId: backendDonation.project_id || backendDonation.projectId,
    amount: backendDonation.amount,
    paymentMethod: backendDonation.payment_method || backendDonation.paymentMethod,
    paymentStatus: backendDonation.payment_status || backendDonation.paymentStatus,
    razorpayPaymentId: backendDonation.easebuzz_payment_id || backendDonation.razorpayPaymentId,
    message: backendDonation.message,
    purpose: backendDonation.purpose || 'General',
    receiptNumber: backendDonation.receipt_number || backendDonation.receiptNumber,
    createdAt: backendDonation.created_at || backendDonation.createdAt,
    donatedAt: backendDonation.donated_at || backendDonation.donatedAt,
    projectTitle: backendDonation.project_title || backendDonation.projectTitle,
    userName: backendDonation.user_name || backendDonation.userName,
    userEmail: backendDonation.user_email || backendDonation.userEmail,
  };
}
